<template>
  <div class="riepilogo-trasferte">

    <transition name="fade">
      <ricerca v-show="showSearchPanel" @closeRicerca="closeSearch" @cerca="cerca" @loadingOff="setLoading(false)"
        :tipoRicerca="'Trasferte_Aut_form'">
      </ricerca>

    </transition>

    <div class="WEB-actions col-24 no-padding">
      <el-button class="WEB-button WEB-button-header left filtri" @click="openSearch">
        <div class="filtri-div">
          <div class="icon-left">
            <icon name="riv-filter" scale="1.4"></icon>
          </div>
          <div class="label">{{ $t('btn.filtri') }}</div>
          <div style="width: 20px"></div>
        </div>
      </el-button>
      <el-button class="WEB-button WEB-button-primary right" @click="opTrasferte('3')">
        {{ $t('btn.approva').toUpperCase() }}
      </el-button>
    </div>

    <el-table :data="listaTrasferte" row-class-name="single riga-hover" @sort-change="sortChange" row-key="idTrasferta"
      @row-click="dettTrasferta" :empty-text="$t('trasferte.msg.noData')" v-loading="loading"
      class="custom-table table-trasferte" :height="100 % - 56 - 50 - 50 - 60 - 5">

      <el-table-column width="70">

        <template slot-scope="scope" slot="header">
          <div class="icon-title">
            <el-popover placement="top" v-model="visibleInfo" :key="scope.toString()">
              <div>
                <div>
                  <icon :name="getStatoIcon('0')" class="status-saved" scale="1.2"></icon>
                  <span>{{ $t('status.0') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('1')" class="status-send" scale="1.2"></icon>
                  <span>{{ $t('status.1') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('2')" class="status-rejected" scale="1.2"></icon>
                  <span>{{ $t('status.2') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('3')" class="status-approved" scale="1.2"></icon>
                  <span>{{ $t('status.3') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('4')" class="status-send" scale="1.2"></icon>
                  <span>{{ $t('status.4') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('4')" class="status-approved" scale="1.2"></icon>
                  <span>{{ $t('status.3') }}</span>
                </div>
                <div>
                  <icon :name="getStatoIcon('7')" class="status-delete" scale="1.2"></icon>
                  <span>{{ $t('status.7') }}</span>
                </div>
              </div>

              <icon class="pointer" name="riv-help" scale="1" slot="reference"></icon>
            </el-popover>

          </div>
        </template>

        <template slot-scope="scope">
          <div class="name-wrapper">
            <el-tooltip class="item" effect="dark" :content="$t(getStatoDes(scope.row))" placement="top-start">
              <icon :name="getStatoIcon(scope.row.statoAvanz)" :class="getStatoClass(scope.row)" scale="1.2"></icon>
            </el-tooltip>
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" prop="dataIn" :label="$t('trasferte.periodo')"
        sortable="custom" width="160">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ formatPeriodo(scope.row) }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" prop="dataIn" :label="$t('trasferte.numOre')"
        sortable="custom" width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.tipoTrasferta === 'ORE' ? scope.row.oreTrasferta : ''}}
          </div>
        </template>

      </el-table-column>

      <!--<el-table-column header-align="center" align="center" prop="dataIn" :label="$t('trasferte.label.dataIn')"
        sortable="custom" width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.dataDal | formattaData }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" prop="dataFin" :label="$t('trasferte.label.dataFin')"
        sortable="custom" width="120">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.dataAl | formattaData }}
          </div>
        </template>

      </el-table-column>-->

      <el-table-column header-align="center" align="center" prop="dip" :label="$t('trasferte.label.employee')"
        sortable="custom">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.nomeDip }} {{ scope.row.cognomeDip }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" :label="$t('trasferte.label.destinazione')">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.desDest === undefined ? scope.row.desMan : scope.row.desDest }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" :label="$t('trasferte.label.soc')">

        <template slot-scope="scope">
          <div class="name-wrapper">
            {{ scope.row.desCli }}
          </div>
        </template>

      </el-table-column>

      <el-table-column width="80">

        <template slot-scope="scope" slot="header">
          <div class="icon-check">
            <el-tooltip class="item" effect="dark" :content="$t('trasferte.msg.selectAllApp')" placement="top-start"
              :key="scope.toString()">
              <icon class="icon col-12 no-padding" name="riv-autorizza" scale="1.3"></icon>
            </el-tooltip>
            <el-checkbox class="check col-12 no-padding" @change="checkConvalida"></el-checkbox>
          </div>
        </template>

        <template slot-scope="scope">
          <div v-if="(scope.row.statoAvanz === '1' && scope.row.seGestView === 'S')" class="offset-12">
            <el-checkbox @click.native.stop v-model="scope.row.checkConvalida"></el-checkbox>
          </div>
        </template>

      </el-table-column>

    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination" background
      layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

  </div>
</template>
<script>
import Ricerca from './Ricerca.vue'
import { bus } from '../Bus.js'

export default {
  components: { Ricerca },
  name: 'RiepilogoAutorizzazioni',
  i18n: {
    messages: {
      it_IT: {
        trasferte: {
          label: {
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            employee: 'Dipendente',
            destinazione: 'Destinazione',
            soc: 'Per Conto della Società'
          },
          msg: {
            info: 'Avviso!',
            abort: 'Operazione Annullata',
            noData: 'Nessun Documento trovato',
            selectAllApp: 'Seleziona tutti i documenti da Approvare',
            confApp: 'Sei sicuro di voler Approvare tutte le trasferte selezionate?',
            noDocsSel: 'Nessun documento selezionato'
          }
        }
      },
      fr_FR: {
        trasferte: {
          label: {
            dataIn: 'Date du',
            dataFin: 'Date au',
            employee: 'Employé',
            destinazione: 'Destination',
            soc: 'pour le compte de'
          },
          msg: {
            info: 'Info!',
            abort: 'Opération annulée',
            noData: 'Aucun document trouvé',
            selectAllApp: 'Sélectionner tous les documents à annuler',
            confApp: 'Êtes-vous sur d\'approuver toutes les demandes de déplacement selectionnées?',
            noDocsSel: 'Aucun document selectionné',
          }
        }
      },
      es_ES: {
        trasferte: {
          label: {
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            employee: 'Empleado',
            destinazione: 'Destino',
            soc: 'Por cuenta de la sociedad'
          },
          msg: {
            info: '¡Aviso!',
            abort: 'Operación cancelada',
            noData: 'Sin informacion',
            selectAllApp: 'Seleccionar todos los documentos pendientes de aprobación',
            confApp: '¿Seguro que quieres aprobar todos los viajes seleccionados?',
            noDocsSel: 'Ningún documento seleccionado',
          }
        }
      },
      de_DE: {
        trasferte: {
          label: {
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            employee: 'Mitarbeiter',
            destinazione: 'Reiseziel',
            soc: 'auf Kosten der Firma',
          },
          msg: {
            info: 'Beachten!',
            abort: 'Operation abgebroche',
            noData: 'Kein Dokument gefunden',
            selectAllApp: 'Wählen Sie alle zu genehmigenden Dokumente aus',
            confApp: 'Möchten Sie wirklich alle ausgewählten Reisen genehmigen?',
            noDocsSel: 'Keine Dokumente ausgewählt'
          }
        }
      },
      en_GB: {
        trasferte: {
          label: {
            dataIn: 'Start Date',
            dataFin: 'End Date',
            employee: 'Employee',
            destinazione: 'Destination',
            soc: 'On Behalf of the Company'
          },
          msg: {
            info: 'Notice!',
            abort: 'Operation Cancelled',
            noData: 'No documents found',
            selectAllApp: 'Select all documents to Approve',
            confApp: 'Are you sure you want to Approve all selected absences?',
            noDocsSel: 'No documents selected'
          }
        }
      }
    }
  },
  data() {
    return {
      visibleInfo: false,
      loading: false,
      showSearchPanel: false,
      showModalDettaglio: false,
      form: {
        dataIn: '',
        dataFin: '',
        statoAvanz: '',
        destinazione: '',
        ccDipendente: '',
        daGestire: true
      },
      listaTrasferte: [],
      trasferta: [],
      dettaglioTrasferta: [],
      nrPages: 0,
      nrItems: 0,
      currentPage: 1,
      pag_for: 40,
      ordine: 'DD'
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  mounted: function () {
  },
  activated: function () {
    this.$emit('setShowNuovo', true)
    this.initialize()
  },
  methods: {
    initialize: function () {
      this.$nextTick(() => {
        if (sessionStorage.hasOwnProperty('Trasferte_Aut_form')) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_Aut_form')))
          //this.ricerca(false)
        }
        this.ricerca(false)
      })
    },
    closeSearch: function () {
      this.$emit('showScroll')
      this.showSearchPanel = false
    },
    openSearch: function () {
      this.showSearchPanel = true
      this.$emit('hideScroll')
    },
    cerca: function (form) {
      let formRicerca = JSON.parse(form)
      this.$set(this, 'form', formRicerca)
      this.currentPage = 1
      this.ricerca(false)
    },
    ricerca: function (flagIfChangeSort) {
      this.loading = true
      if (flagIfChangeSort === true) {
        this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_Aut_form')))
        this.currentPage = 1
      }
      let numStatiAvanz = ''
      let statoAvanz = ''
      if (this.form.statoAvanz == '' || this.form.statoAvanz == 'all') {
        statoAvanz = ''
        numStatiAvanz = "0";
      } else {
        statoAvanz = this.form.statoAvanz;
        numStatiAvanz = "1"
      }
      sessionStorage.setItem('Trasferte_Aut_form', JSON.stringify(this.form))
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          vista: 'R',
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.ordine,
          dataDal: this.form.dataDal,
          dataAl: this.form.dataAl,
          statoAvanz: statoAvanz,
          numStatiAvanz: numStatiAvanz,
          destinazione: this.form.destinazione,
          ccDipendente: this.form.ccDipendente,
          daGestire: this.form.daGestire === undefined || this.form.daGestire ? 'si' : 'no',
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.listaTrasferte = response.body.data.map(function (obj) {
              obj.checkConvalida = false
              return obj
            })
            // this.listaTrasferte = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$set(this, 'listaTrasferte', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.closeSearch()
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.ricerca(false)
    },
    /*  Viene richiamata quando l'utente clicca sulle frecce di ordinamento della tabella. Setta il codice di ordinamento corrispondente
     *  e richiama il servizio di ricerca con questo codice
     */
    sortChange: function ({ column, prop, order }) {
      if (prop === 'dataIn') {
        if (order === 'ascending') {
          this.ordine = 'DA'
        } else if (order === 'descending') {
          this.ordine = 'DD'
        }
      } else if (prop === 'dataFin') {
        if (order === 'ascending') {
          this.ordine = 'AA'
        } else if (order === 'descending') {
          this.ordine = 'AD'
        }
      } else if (prop === 'dip') {
        if (order === 'ascending') {
          this.ordine = 'CA'
        } else if (order === 'descending') {
          this.ordine = 'CD'
        }
      } else {
        this.ordine = 'DD'
      }
      this.ricerca(true)
    },
    dettTrasferta: function (row, event, column) {
      this.$router.push({ name: 'AutorizzaTrasferta', params: { id: row.idTrasferta } })
    },
    getStatoDes: function (record) {
      switch (record.statoAvanz) {
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === "" || record.statoAlloggio === "3") &&
            (record.statoMensa === undefined || record.statoMensa === "" || record.statoMensa === "3") &&
            (record.statoBiglietti === undefined || record.statoBiglietti === "" || record.statoBiglietti === "3") &&
            (record.statoTrasporti === undefined || record.statoTrasporti === "" || record.statoTrasporti === "3") &&
            (record.statoAutoAz === undefined || record.statoAutoAz === "" || record.statoAutoAz === "3")) {
            return 'status.3'
          } else {
            return 'status.' + record.statoAvanz
          }
        default:
          return 'status.' + record.statoAvanz
          break;
      }
    },
    getStatoIcon: function (stato) {
      switch (stato) {
        case '0':
          return 'riv-save2'
        case '1':
        case '2':
        case '3':
          return 'riv-user'
        case '4':
          return 'riv-alloggio'
        case '7':
          return 'elm-chiudi'
        default:
          return ''
      }
    },
    getStatoClass: function (record) {
      switch (record.statoAvanz) {
        case '0':
          return 'status-saved'
        case '1':
          return "status-send"
        case '2':
          return "status-rejected"
        case '3':
          return "status-approved"
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === "" || record.statoAlloggio === "3") &&
            (record.statoMensa === undefined || record.statoMensa === "" || record.statoMensa === "3") &&
            (record.statoBiglietti === undefined || record.statoBiglietti === "" || record.statoBiglietti === "3") &&
            (record.statoTrasporti === undefined || record.statoTrasporti === "" || record.statoTrasporti === "3") &&
            (record.statoAutoAz === undefined || record.statoAutoAz === "" || record.statoAutoAz === "3")) {
            return "status-approved"
          } else {
            return "status-send"
          }
        case '7':
          return 'status-delete'
          break;
        default:
          return ''
          break;
      }
    },
    checkConvalida: function (event) {
      for (var i = 0; i < this.listaTrasferte.length; i++) {
        if (this.listaTrasferte[i].statoAvanz === '1') this.listaTrasferte[i].checkConvalida = event
      }
    },
    opTrasferte: function (statoAvanz) {
      let _this = this;

      let message = this.$i18n.t('trasferte.msg.confApp')
      let btnOK = this.$i18n.t('btn.approva')

      this.$confirm(message, 'Info', {
        confirmButtonText: btnOK,
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {

            let counter = 0
            let righe = []

            for (let item of _this.listaTrasferte) {
              if (item.checkConvalida) {
                counter++
                let obj = {
                  idTrasferta: item.idTrasferta,
                  operazione: "*UPD",
                  statoAvanz: statoAvanz,
                  ccDipendente: item.ccDipendente
                }
                righe.push(obj)
              }
            }
            if (counter === 0) {
              _this.$message({
                showClose: true,
                message: _this.$i18n.t('trasferte.msg.noDocsSel'),
                type: 'warning',
                duration: process.env.duration
              })
            } else {
              _this.loading = true
              let obj = {
                'numRec': counter,
                'trasferte': righe
              }
              _this.$http.post('trasferte/' + _this.$store.state.country + '/approvazione', obj).then(response => {
                if (response.body.rc === 0) {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                  _this.ricerca()
                } else {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'warning',
                    duration: process.env.duration
                  })
                }
                _this.loading = false
              })
            }
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('trasferte.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
      });
    },
    formatPeriodo: function(row) {
      if (row.tipoTrasferta === 'GIO' && row.dataDal !== '' && row.dataAl) {
        return (row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4)) + ' - ' +
          (row.dataAl.substr(6, 2) + '/' + row.dataAl.substr(4, 2) + '/' + row.dataAl.substr(0, 4))
      } else  if (row.tipoTrasferta === 'ORE' && row.dataDal !== '') {
        return (row.dataDal.substr(6, 2) + '/' + row.dataDal.substr(4, 2) + '/' + row.dataDal.substr(0, 4)) +
        ' (' + row.oraDal + ' - ' + row.oraAl + ')'
      }
    },
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/el-table.less";
@import "../../assets/less/el-pagination.less";
@import "../../assets/less/el-button.less";

.riepilogo-trasferte {
  height: 100%;

  .table-trasferte {
    margin-top: 10px;
    // WEB-header (56px) - WEB-title (50px) WEB-Action (50px) WEB-paginator (60px)
    height: calc(100vh - 56px - 50px - 50px - 60px - 5px);
  }

  .header-tab {
    height: 65px;
    // border-bottom: 1px solid #007c74;
    text-align: center;

    .icon-search {
      line-height: 65px;

      .el-button {
        height: 40px;
        width: 40px;
        border-radius: 0px;
        margin-top: 12px;
        margin-left: 10px;
        padding: 0px;
        color: @greenRiva;
        float: left;
        border: 1px solid @greenRiva;
      }

      .el-button:hover {
        background-color: @white;
      }
    }

    .action {
      text-align: right;

      .el-button {
        margin-top: 12px;
        margin-right: 10px;
      }
    }
  }

}

.status-send {
  color: @orangeMedium
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

/*.riepilogo-trasferte, .modal-dettaglio {
    .el-table::before {
      height: 0px;
    }
    .el-table {
      border-bottom: none;
      height: 430px;
      overflow: auto;
      .el-table__empty-text {
        margin-top: 15px;
      }
      .el-table__fixed-right {
        box-shadow: none;
        -webkit-box-shadow: none;
        .el-table__fixed-body-wrapper {
          top: 40px !important;
        }
      }
      .el-table__fixed-right::before {
        height: 0px;
      }
      .el-table__header {
        border-bottom: 1px solid @greenRiva;
        thead {
          th {
            padding: 5px 0px 0px 0px;
            &:not(.is-sortable) {
              .cell {
                margin-top: -7px;
              }
            }
            .cell {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-left: 10px !important;
              .set-font(@color: @greenRiva; @weight: bold; @size: 15px);
            }
            &.is-sortable {
              padding-top: 5px !important;
            }
            &.is-leaf {
              border: 0px;
            }
          }
        }
      }
      .el-table__body {
        tbody {
          tr {
            &.expanded {
              background-color: #e7e7e7;
              td {
                background-color: #e7e7e7 !important;
              }
            }
            &.hover-row {
              td {
                background-color: @white;
              }
            }
            &.single {
              .el-table__expand-icon {
                display: none;
              }
            }
            td {
              padding-top: 5px;
              padding-bottom: 5px;
              .cell {
                .set-font(@size: 12px; @color: #606266);
                .pointer:hover {
                  cursor: pointer;
                }
                .fa-icon {
                  margin-top: 4px;
                }
              }
              -webkit-transition: none;
              transition: none;
            }
            .el-table__expanded-cell {
              padding: 0px !important;
              .el-table__header-wrapper {
                display: none;
              }
              .el-table {
                height: auto !important;
                .el-table__body {
                  tr {
                    td {
                      border-bottom: 0px;
                      &.cella-evidenziata {
                        background-color: #e7e7e7;
                      }
                    }
                  }
                }
              }
              .el-table::before {
                height: 0px;
              }
              .el-table__empty-block {
                display: none;
              }
            }
          }
        }
      }
    }
  }*/
</style>



// WEBPACK FOOTER //
// src/components/Trasferte/RiepilogoAutorizzazioni.vue